import type { AdCreativeAssetReference, AdCreativeItem } from '@segmently/schema-models/ad-creative';

/** Resolve only the exact source-locale video bytes on a strict v3 Segmently copy. */
export function exactSourceVideoAsset(
  item: AdCreativeItem,
  slotKey: string,
): AdCreativeAssetReference | null {
  if (item.entityKind !== 'segmently_copy') return null;
  const slot = item.localizedMedia?.[slotKey];
  if (!slot || slot.mediaKind !== 'video') return null;
  const translations = slot.translations ?? {};
  const entry = Object.prototype.hasOwnProperty.call(translations, item.defaultLanguage)
    ? translations[item.defaultLanguage]
    : undefined;
  const asset = entry?.disabled ? undefined : entry?.asset;
  if (!asset
    || !asset.assetId?.trim()
    || !asset.original?.trim()
    || !asset.mimeType?.startsWith('video/')
    || !/^[a-f0-9]{64}$/.test(asset.sha256 ?? '')) {
    return null;
  }
  return asset;
}

/** Resolve an exact source video whose geometry and duration can drive timed visual review. */
export function exactSourceVideoAssetWithGeometry(
  item: AdCreativeItem,
  slotKey: string,
): AdCreativeAssetReference | null {
  const asset = exactSourceVideoAsset(item, slotKey);
  if (!asset
    || !Number.isSafeInteger(asset.width)
    || !Number.isSafeInteger(asset.height)
    || !Number.isSafeInteger(asset.durationMs)
    || (asset.width ?? 0) <= 0
    || (asset.height ?? 0) <= 0
    || (asset.durationMs ?? 0) <= 0) {
    return null;
  }
  return asset;
}
